export const environment = {
    production: true,
    api: 'https://dev.api.classichub.co.nz',
    buildVersion: '2026.7.2.2',
    uri: 'https://dev.classichub.co.nz',
    envName: 'dev',
    isTest: true,
};

